// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
// RxJS
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
// Auth reducers and selectors
import { AppState} from '../../../core/reducers/';
import { isLoggedIn } from '../_selectors/auth.selectors';
import { environment } from '../../../../environments/environment';
import { jwtDecode } from 'jwt-decode';
import { AuthService } from '../_services';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private readonly store: Store<AppState>, private readonly router: Router,
        private readonly auth: AuthService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>  {
        return this.store
            .pipe(
                select(isLoggedIn),
                tap(loggedIn => {
                    if (!loggedIn || this.isTokenExpired()) {
                        if (environment.runtime.enableSAMLSSO && environment.runtime.DIRECT_REDIRECT_SAML && environment.runtime.DIRECT_SAML_URL != "") {
                            this.auth.redirectToSAML();
                        } else if (!state.url.includes('/web/login')) {
                            this.router.navigate(['/web/login'], { queryParams: { returnUrl: state.url } });
                        }
                    } else if (environment.runtime.SUBSCRIPTION_EXPIRED && environment.runtime.SUBSCRIPTION_EXPIRY_TYPE == 1)
                        this.router.navigate(['/web/subscription']);
                })
            );
    }

    isTokenExpired(): boolean {
        const userToken = localStorage.getItem(environment.runtime.authTokenKey);
        if (!userToken) {
            return true;
        }
        try {
            const tokenPayload = jwtDecode(userToken).exp * 1000;;
            const currentTime = Date.now();
            return !tokenPayload || tokenPayload <= currentTime;
        } catch (error) {
            return true;
        }
    }
}
